import { createWorkflow } from './api';

export { useWorkflowStatus } from './api';

export const useShipWorkflow = createWorkflow({
  name: 'Ship',
});

export const useShipToIntraWorkflow = createWorkflow({
  name: 'ShipToIntra',
});

export const useSoScheduleWorkflow = createWorkflow({
  name: 'SOSchedule',
});
